module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("A Canadian Girl in South Africa")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle-pre"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("WE WOULD LIKE TO THANK")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("John and Delores Becker for supporting this project and for generously providing us with Maud Graham’s South Africa photo album. We also very much appreciate Joan Chandler’s assistance in locating photographs and helping us with some additional historical context. Helen Millar Becker carefully preserved many of Maud Graham’s papers and photographs and wrote up her own recollections of Graham. This book is much richer for her work of historical preservation. Our thanks as well to Wyn Millar and R.D. Gidney, who provided useful commentary on the Introduction and to the anonymous assessors who provided valuable ideas and suggestions for the book.")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', [_vm._v("A General Research Grant from St. Thomas University facilitated research in Toronto, Ottawa, and Owen Sound, Ontario. Funding from the St. Thomas University JOBS Programme and the Social Sciences and Humanities Research Council allowed us to hire Ashley Doiron and Molly Egerdie as research assistants. Both of these students made important contributions to this project.")]), _vm._v(" "), _c('p', [_vm._v("Peter Midgley has provided enthusiastic support for this project from the very beginning. We would like to thank him, as well as the production staff at University of Alberta Press, who did a wonderful job—especially when it came to the tricky task of working with old photographs. We also very much appreciated Joanne Muzak’s copyediting skills.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("Maud Graham’s South Africa photo album, her scrapbook, as well as additional family papers will be donated to the Thomas Fisher Rare Book Library, University of Toronto.")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85a744a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Acknowledgements.vue
// module id = 66
// module chunks = 0